<ng-http-loader
  [filteredUrlPatterns]="filteredUrls"
  [entryComponent]="httploadingSpinnerComponent"
  opacity="1"
  backdropBackgroundColor="rgba(255, 255, 255, 0.88)"
></ng-http-loader>
<div *ngIf="showUpdateBanner" class="app-update-banner" role="alert" aria-live="assertive">
  <span class="app-update-banner__text">
    <i class="bi bi-arrow-repeat"></i>
    A new version is available. The page will reload in {{ updateCountdown }} second{{ updateCountdown === 1 ? '' : 's' }}.
  </span>
  <button type="button" class="btn btn-sm btn-light app-update-banner__btn" (click)="reloadNow()">Reload now</button>
</div>
<!-- Demo auth is not in use. <app-demo-login *ngIf="showDemoLogin$ | async"></app-demo-login> -->
<div [class.demo-overlay]="showDemoLogin$ | async">
  <router-outlet *ngIf="!(showDemoLogin$ | async)"></router-outlet>
  <router-outlet name="account-portal"></router-outlet>
</div>
  <app-error></app-error>
  <ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">
        <i class="text-warning bi bi-exclamation-triangle-fill"></i> Notification
      </h4>
    </div>
    <div class="modal-body">
      <p>{{ notificationMessage }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="px-4 btn btn-default modal-ok-button text-white" (click)="c('ok')">Ok</button>
    </div>
  </ng-template>

